import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "../../shared/pagination";

const AddParty = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "profile");
  const [stateDrp, setStateDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [partySalesItemsData, setPartySalesItemsData] = useState([]);
  const [itemWiseReportDateRange, setItemWiseReportDateRange] = useState("thisMonth");
  const [transactionList, setTransactionList] = useState([]);
  const [transactionCurrentPage, setTransactionCurrentPage] = useState(1);
  const [transactionTotalPages, setTransactionTotalPages] = useState(1);
  const [transactionTotal, setTransactionTotal] = useState(0);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const itemsPerPage = 30;
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    city_id: "",
    state_id: "",
    address: "",
    pincode: "",
    gst_no: "",
    pan_no: "",
    country_id: 101,
    email:"",
    contact_no:"",
  });

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
    }),
  };

  const itemWiseReportDateRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "last365Days", label: "Last 365 Days" },
  ];

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      city: "",
      state_id: "",
      address: "",
      pincode: "",
      gst_no: "",
      pan_no: "",
      email:"",
      contact_no:"",
        });
  };

  const getStateDrpData = () => {
    axios
      .post(API_URL.STATE_LIST, { country_id: formValue.country_id })
      .then((res) => {
        setStateDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setStateDrpData(cd);
      });
  };

  const getDateRangeForItemWiseReport = (rangeKey) => {
    const formatYmd = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    let fromDate, toDate;
    switch (rangeKey) {
      case "today":
        fromDate = toDate = formatYmd(today);
        break;
      case "yesterday": {
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        fromDate = toDate = formatYmd(yesterday);
        break;
      }
      case "thisMonth": {
        fromDate = formatYmd(new Date(today.getFullYear(), today.getMonth(), 1));
        toDate = formatYmd(today);
        break;
      }
      case "lastMonth": {
        const lastMonthFirst = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthLast = new Date(today.getFullYear(), today.getMonth(), 0);
        fromDate = formatYmd(lastMonthFirst);
        toDate = formatYmd(lastMonthLast);
        break;
      }
      case "last365Days": {
        const from = new Date(today);
        from.setDate(from.getDate() - 365);
        fromDate = formatYmd(from);
        toDate = formatYmd(today);
        break;
      }
      default:
        fromDate = formatYmd(new Date(today.getFullYear(), today.getMonth(), 1));
        toDate = formatYmd(today);
    }
    return { from_date: fromDate, to_date: toDate };
  };

  const getPartySalesItems = (dateRangeKey = itemWiseReportDateRange) => {
    if (!id) return;
    const { from_date, to_date } = getDateRangeForItemWiseReport(dateRangeKey);
    axios.post(API_URL.PARTY_SALES_ITEMS, { party_id: id, from_date, to_date }).then((res) => {
      if (res.data.status === 1) {
        setPartySalesItemsData(res.data.data || []);
      } else {
        toast.error(res.data.data, { autoClose: 3000 });
      }
    }).catch((error) => {
      toast.error("Something went wrong..", {
        autoClose: 3000,
        position: "top-right",
      });
    });
  };
  
  const getTransactionList = (page = 1) => {
    if (!id) return;
    setTransactionLoading(true);
    axios
      .post(API_URL.PAYMENT_LIST, { 
        party_id: id,
        page: page,
        limit: itemsPerPage
      })
      .then((res) => {
        if (res.data.status === 1) {
          setTransactionList(res.data.data.data || []);
          const total = res.data.data.total || 0;
          setTransactionTotalPages(Math.ceil(total / itemsPerPage));
          setTransactionTotal(total);
        }
        setTransactionLoading(false);
      })
      .catch(() => {
        setTransactionLoading(false);
        toast.error("Failed to load transactions", { autoClose: 3000 });
      });
  };

  const handleTransactionPageChange = (page) => {
    setTransactionCurrentPage(page);
    getTransactionList(page);
  };

  const getCityDrpData = () => {
    axios
      .post(API_URL.CITY_LIST, {state_id:formValue.state_id})
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };

  const deleteTransaction = (transaction) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + transaction.party_name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(API_URL.PAYMENT_DELETE, { id: transaction.id }).then(
          (res) => {
            if (res.data.status == 1) {
              getTransactionList(transactionCurrentPage);
              toast.success("Delete Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
          },
          (error) => {
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  const onEdit = () => {
    axios.post(API_URL.PARTY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : 101,
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          address: res.data.data.address
            ? res.data.data.address
            : "",
          pincode: res.data.data.pincode ? res.data.data.pincode : "",
          gst_no: res.data.data.gst_no ? res.data.data.gst_no : "",
          pan_no: res.data.data.pan_no ? res.data.data.pan_no : "",
          email: res.data.data.email ? res.data.data.email : "",
          contact_no: res.data.data.contact_no ? res.data.data.contact_no : "",
        });
      }
    });
  };

  const saveParty = () => {
    if (
      formValue.name &&
      formValue.city_id &&
      formValue.state_id &&
      formValue.contact_no
    ) {
      const pUrl = id ? API_URL.PARTY_UPDATE : API_URL.PARTY_SAVE;
      axios.post(pUrl, {...formValue, is_seller: 0}).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", { autoClose: 3000 });
            setTimeout(() => {
              navigate("/sales/party", { replace: true });
            }, 100);
          } else {
            resetForm();
            toast.success("Saved", { autoClose: 3000 });
          }
        } else {
          toast.error(res.data.data, { autoClose: 3000 });
        }
      });
    }
  };

  const isValidForm = () => {
    return (
      formValue.name &&
      formValue.city_id &&
      formValue.state_id &&
      formValue.contact_no
    );
  };

  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  useEffect(() => {
    getCityDrpData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);
 
  useEffect(() => {
    getStateDrpData();
    if (searchParams.get("tab")) {
      setActiveTab(searchParams.get("tab"));
      if (searchParams.get("tab") === "transaction") {
        getTransactionList(1);
      } else if (searchParams.get("tab") === "itemWiseReport") {
        getPartySalesItems();
      }
    }
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
            <h1>{id ? "Edit" : "Add"} Party</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/sales/party"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          {id && (
            <ul className="nav nav-tabs separator-tabs mb-1" role="tablist">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
                  onClick={() => setActiveTab("profile")}
                  style={{ cursor: "pointer" }}
                >
                  Profile
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "transaction" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("transaction");
                    setTransactionCurrentPage(1);
                    getTransactionList(1);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Transaction
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "itemWiseReport" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("itemWiseReport");
                    getPartySalesItems();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Item Wise Report
                </a>
              </li>
            </ul>
          )}
          <div className="card">
            <div className="card-body">
              <div className={id ? "tab-content" : ""}>
                <div className={id ? `tab-pane ${activeTab === "profile" ? "active" : ""}` : ""}>
                  <form onSubmit={(event) => event.preventDefault()}>
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Name<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            value={formValue.name}
                            onChange={(e) => setFormData("name", e.target.value)}
                            className="form-control"
                            placeholder="Enter Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Email</label>
                          <input
                            type="text"
                            value={formValue.email}
                            onChange={(e) => setFormData("email", e.target.value)}
                            className="form-control"
                            placeholder="Email"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Contact Number<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            value={formValue.contact_no}
                            onChange={(e) => setFormData("contact_no", e.target.value)}
                            className="form-control"
                            placeholder="Contact Number"
                          />
                        </div>
                      </div>                  
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>State<span className="text-danger">*</span></label>
                          <Select
                            options={stateDrp}
                            value={stateDrp.find((r) => r.value == formValue.state_id)}
                            styles={styles}
                            onChange={(e) => setFormValue({ ...formValue,state_id: e.value})}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="City">City<span className="text-danger">*</span></label>
                          <Select
                            options={cityDrp}
                            value={cityDrp.find((r) => r.value == formValue.city_id)}
                            styles={styles}
                            onChange={(e) =>
                              setFormValue({ ...formValue,city_id: e.value })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Address</label>
                          <input
                            type="text"
                            value={formValue.address}
                            onChange={(e) => setFormData("address", e.target.value)}
                            className="form-control"
                            placeholder="Address"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Pincode</label>
                          <input
                            type="text"
                            value={formValue.pincode}
                            onChange={(e) => setFormData("pincode", e.target.value)}
                            className="form-control"
                            placeholder="Pincode"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>GST Number</label>
                          <input
                            type="text"
                            value={formValue.gst_no}
                            onChange={(e) => setFormData("gst_no", e.target.value)}
                            className="form-control"
                            placeholder="GST Number"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Pan Number</label>
                          <input
                            type="text"
                            value={formValue.pan_no}
                            onChange={(e) => setFormData("pan_no", e.target.value)}
                            className="form-control"
                            placeholder="Pan Number"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                        <div className="form-group text-right">
                          <button
                            type="submit"
                            onClick={saveParty}
                            disabled={!isValidForm()}
                            className="btn btn-primary"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {id && (
                  <>
                    <div className={`tab-pane ${activeTab === "transaction" ? "active" : ""}`}>
                      <div className="row">
                        <div className="col-12">
                          <div className="table-responsive">
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th width="50px">#</th>
                                  <th width="120px">Payment</th>
                                  <th width="120px">Date</th>
                                  <th>Payment Mode</th>
                                  <th width="120px">Amount</th>
                                  <th>Remark</th>
                                  <th width="150px">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactionLoading ? (
                                  <tr>
                                    <td colSpan="7" className="text-center">
                                      <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="sr-only">Loading...</span>
                                      </div>
                                    </td>
                                  </tr>
                                ) : transactionList.length > 0 ? (
                                  transactionList.map((transaction, key) => (
                                    <tr key={transaction.id}>
                                      <td>{(transactionCurrentPage - 1) * itemsPerPage + key + 1}</td>
                                      <td>
                                        <span className={`badge ${
                                          transaction.payment_type === "Received" 
                                            ? "badge-success" 
                                            : "badge-danger"
                                        }`}>
                                          {transaction.payment_type || "-"}
                                        </span>
                                      </td>
                                      <td>{transaction.payment_date || transaction.date}</td>
                                      <td>{transaction.payment_mode || "-"} {transaction.bank_name ? ' - ' + transaction.bank_name : ''}</td>
                                      <td>₹{parseFloat(transaction.amount || 0).toFixed(2)}</td>
                                      <td>{transaction.remark || "-"}</td>
                                      <td className="action-td">
                                          {transaction.payment_view === "Direct" && (
                                              <>
                                                  <Link to={"/payments/edit/" + transaction.id}>
                                                      <button className="btn btn-sm btn-primary mr-2">
                                                          <i className="fa fa-edit me-1"></i> Edit
                                                      </button>
                                                  </Link>
                                                  <button
                                                      onClick={() => deleteTransaction(transaction)}
                                                      className="btn btn-sm btn-danger me-2"
                                                  >
                                                      <i className="fa fa-trash me-1"></i> Delete
                                                  </button>
                                              </>
                                          )}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center">
                                      No transactions found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          {transactionTotalPages > 1 && (
                            <div className="d-flex justify-content-center my-3">
                              <Pagination
                                currentPage={transactionCurrentPage}
                                totalPages={transactionTotalPages}
                                onPageChange={handleTransactionPageChange}
                              />
                            </div>
                          )}
                          {transactionTotal > 0 && (
                            <div className="text-muted text-center">
                              Showing {((transactionCurrentPage - 1) * itemsPerPage) + 1} to{" "}
                              {Math.min(transactionCurrentPage * itemsPerPage, transactionTotal)} of{" "}
                              {transactionTotal} transactions
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={`tab-pane ${activeTab === "itemWiseReport" ? "active" : ""}`}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group mb-3">
                            <div className="d-inline-block" style={{ minWidth: 180 }}>
                              <Select
                                options={itemWiseReportDateRangeOptions}
                                value={itemWiseReportDateRangeOptions.find(
                                  (o) => o.value === itemWiseReportDateRange
                                )}
                                onChange={(option) => {
                                  const value = option.value;
                                  setItemWiseReportDateRange(value);
                                  getPartySalesItems(value);
                                }}
                                styles={styles}
                              />
                            </div>
                          </div>
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {partySalesItemsData.map((item, key) => (
                                  <tr key={key}>
                                    <td>{item.product_name}</td>
                                    <td>{item.total_qty}</td>
                                    <td>₹{parseFloat(item.total_amount || 0).toFixed(2)}</td>
                                  </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddParty;
